import React from 'react';
import PropTypes from 'prop-types';
import SocialIcons from '@components/SocialIcons';
import Nav from '@components/Nav';
import ScrollToNext from '@components/ScrollToNext';
import BrowserNotes from '@components/BrowserNotes';
import logo from '@images/cairo-flying.png';

import './style.scss';

const LandingPage = (props, context) => {
  const { theme: { bgPrimary, colorPrimary } } = context;

  return (
    <div style={{ backgroundColor: bgPrimary }} className="landing-page">
      <Nav />
      <main style={{ color: colorPrimary }}>
        <BrowserNotes />
        <div className="intro-wrapper">
          <div className="intro-name">Hello, I'm Cairo!</div>
          <div className="tagline">(pronounced <b><i>chai-row</i></b>, or <b>菜肉</b>)</div>
          <div className="logo">
            <img src={logo} alt="cairo stylized"/>
          </div>
          <div className="tagline">
            Angsty Teenager | Sweet Talker | Escapologist
          </div>
          <SocialIcons />
        </div>
      </main>
      <ScrollToNext pageSelector=".about-page" />
    </div>
  );
};

LandingPage.contextTypes = {
  theme: PropTypes.any
};

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingPage.js